import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardInvoicesByOrder = createAsyncThunk("fetchRewardInvoicesByOrder", async (id) => {
	const response = await axiosHttp.get(`order/${id}/invoices`);
	return response.data.data;
});

const RewardInvoicesByOrderSlice = createSlice({
	name: "RewardInvoicesByOrderSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardInvoicesByOrder.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardInvoicesByOrder.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardInvoicesByOrder.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RewardInvoicesByOrderSlice.reducer;
